export enum ImporterTemplate {
	DEFAULT_TEMPLATE = 'default',
	VERSION_POPUP = 'versionPopup',
}
